import { LinkSignInPanel } from '@/features/auth';

export function SignInLinkPage() {
  return <LinkSignInPanel />;
}
